import { get } from 'core_main/request';
import { GET_AUTOMATIONS_METADATA_ENDPOINT } from './constants';

export const fetchAutomationsMetadata = () => {
  return get(GET_AUTOMATIONS_METADATA_ENDPOINT);
};
